import { $http } from '@/utils/https';
import type { ActionContext } from 'vuex';
import type { RootState } from '@/store';
import type { IProductWhenAvailablePayload } from '@/store/modules/types/products';
import type { User } from '@/types/user';
import type { Product } from '@/types/shop';

interface State {
  showNotifyLoader: boolean;
  product: Product | null;
}

const state: State = {
  showNotifyLoader: false,
  product: null
};

const getters = {
  showNotifyLoader: (state: State) => state.showNotifyLoader,
  product: (state: State) => state.product
};

const actions = {
  SHOW_POPUP_PRODUCT_WHEN_AVAILABLE: async (
    context: ActionContext<State, RootState>,
    payload: IProductWhenAvailablePayload
  ) => {
    const currentUser: User | null = context.rootGetters['profile/user'];
    // if no city - show popup
    if (!currentUser || !currentUser.city) {
      context.commit('popups/SHOW_NOTIFY_WHEN_AVAILABLE', { status: true, notifyPayload: payload }, { root: true });
      return;
    }

    const showThanksPopup = () => {
      context.commit(
        'popups/SHOW_SEMINAR_DETAILS_POPUP',
        {
          status: true,
          data: {
            title: '',
            detail: "Дякуємо за звернення! Щойно продукт з'явиться в наявності, ми обов'язково Вам повідомимо"
          }
        },
        { root: true }
      );
    };

    try {
      await context.dispatch('SET_PRODUCT_WHEN_AVAILABLE', payload);
      showThanksPopup();
    } catch (e) {
      showThanksPopup();
    }
  },
  SET_PRODUCT_WHEN_AVAILABLE: async (
    { commit }: ActionContext<State, RootState>,
    payload: IProductWhenAvailablePayload
  ) => {
    commit('SHOW_NOTIFY_LOADER', true);
    try {
      await $http.post<{ message: string }>('v1/products/notify-when-available', payload);
    } catch (e) {
      throw e;
    } finally {
      commit('SHOW_NOTIFY_LOADER', false);
    }
  },
  GET_PRODUCT: async ({ commit }: any, slug: any) => {
    commit('RESET_PRODUCT');
    let url = `v1/catalog/product/${slug}`;
    try {
      const response = await $http.get(url);
      commit('SET_PRODUCT', response.data.data);
    } catch (e) {
      throw e;
    }
  },
  // eslint-disable-next-line no-unused-vars
  GET_PRODUCTS: async ({ commit }: any, payload: any) => {
    try {
      const response = await $http.get<{ data: Array<Product> }>(`v1/products`, {
        params: payload
      });

      return response.data;
    } catch (e) {
      throw e;
    }
  }
};

const mutations = {
  SHOW_NOTIFY_LOADER(state: State, status: boolean) {
    state.showNotifyLoader = status;
  },
  SET_PRODUCT(state: State, product: Product) {
    state.product = product;
  },
  RESET_PRODUCT(state: State) {
    state.product = null;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
